import React, { Component, Fragment } from 'react';
import DecisionTypeRow from './DecisionTypeRow';
import { Row, Col, Card, Table } from 'react-bootstrap';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import ModalForAddDecisionType from './ModalForAddDecisionType';
import SearchFilter from '../Reusable/SearchFilter';
import withTranslations from '../../utils/HighOrderComponent';
import { addNewButton } from '../../utils';

class DecisionTypeTable extends Component {
  constructor() {
    super();
    this.state = {
      show: false,
    };
  }

  showModal = (e) => {
    this.setState({
      show: true,
    });
    this.isModalOpened(true);
  };

  handlePreviewClose = () => {
    this.setState({ show: false });
    this.props.deleteError();
    this.isModalOpened(false);
  };

  handleAdd = (decisionType) => {
    const { Labels } = this.props.t;
    this.props.createDecisionType(
      decisionType,
      this.handlePreviewClose,
      Labels?.titleTable
    );
  };

  handleAddDecisionTypeWithAttachment = (formData, type) => {
    const { Labels } = this.props.t;
    this.props.createDecisionTypeWithAttachment(
      formData,
      this.handlePreviewClose,
      type,
      Labels?.titleTable
    );
  };

  isModalOpened = (isOpened) => {
    this.props.isModalOpened(isOpened);
  };

  render() {
    const {
        t,
        error,
        deleteError,
        deleteDecisionType,
        updateDecisionType,
        findDecisionTypeAttachment,
        findDecisionTypeAttachmentByDecisionTypeName,
      } = this.props || {},
      { HeaderColumns, Labels, Tooltips } = t || {},
      { titleTable } = Labels || {};

    const decisionTypeList = this.props.decisionTypeList?.map(
      (decisionType, index) => (
        <DecisionTypeRow
          index={index + 1}
          key={decisionType.id}
          decisionType={decisionType}
          deleteDecisionType={deleteDecisionType}
          updateDecisionType={updateDecisionType}
          deleteError={deleteError}
          error={error}
          findDecisionTypeAttachment={findDecisionTypeAttachment}
          findDecisionTypeAttachmentByDecisionTypeName={
            findDecisionTypeAttachmentByDecisionTypeName
          }
          decisionContent={this.props.decisionContent}
          format={this.props.format}
          updateDecisionTypeWithAttachment={
            this.props.updateDecisionTypeWithAttachment
          }
          deleteErrorDecisionTypeAttachment={
            this.props.deleteErrorDecisionTypeAttachment
          }
          messageTitle={titleTable}
        />
      )
    );

    const table = (
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Row>
                <Col className="col-md-8">
                  <Card.Title as="h3">{titleTable}</Card.Title>
                </Col>
                <Col className="col-md-3">
                  <SearchFilter noSearchColums={2} />
                </Col>
                <Col className="addUser col-md-1">
                  {addNewButton(() => this.showModal(), Tooltips.addNew)}
                </Col>
              </Row>
            </Card.Header>
            <Table responsive hover id="table">
              <thead>
                <tr className="text-center">
                  <th width="5%" className="text-left">
                    #
                  </th>
                  <th>{HeaderColumns.name}</th>
                  <th>{HeaderColumns.description}</th>
                  <th>{HeaderColumns.preview}</th>
                  <th>{HeaderColumns.edit}</th>
                  <th>{HeaderColumns.delete}</th>
                </tr>
              </thead>
              <tbody>{decisionTypeList}</tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    );

    return (
      <Fragment>
        {table}
        {this.state.show && (
          <ModalForAddDecisionType
            handleAdd={this.handleAdd}
            handleAddDecisionTypeWithAttachment={
              this.handleAddDecisionTypeWithAttachment
            }
            handleClose={this.handlePreviewClose}
            show={this.state.show}
            error={error}
            deleteError={deleteError}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(DecisionTypeTable, 'DecisionTypeTable');
